import { render, staticRenderFns } from "./DetailsJobTitleArg.vue?vue&type=template&id=480d6583&"
import script from "./DetailsJobTitleArg.vue?vue&type=script&lang=js&"
export * from "./DetailsJobTitleArg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports